import type { RequestResponse } from '@/types/publicType'
import type {
  roomPrepareCheckInterface,
  roomGetCoverInfoInterface
} from '@/types/apiType/liveType'

/**
 * 开播前置检查
 */
export function apiRoomPrepareCheck(): Promise<
  RequestResponse<roomPrepareCheckInterface>
> {
  return getFetchData({
    url: '/room/prepare/check',
    method: 'POST'
  })
}

/**
 * 获取封面图
 * @param {3|6} roomType
 */
export function apiRoomGetCoverInfo(data: {
  roomType: 3 | 6
}): Promise<RequestResponse<roomGetCoverInfoInterface>> {
  return getFetchData({
    url: '/room/getCoverInfo',
    method: 'POST',
    data
  })
}

/**
 * 获取封面图
 * @param {3|6} roomType 房间类型
 * @param {string} coverUrl 图片链接
 */
export function apiRoomSaveCoverUrl(data: {
  roomType: 3 | 6
  coverUrl: string
}): Promise<RequestResponse<roomGetCoverInfoInterface>> {
  return getFetchData({
    url: '/room/save/coverUrl',
    method: 'POST',
    data
  })
}

/**
 * 开播前置检查
 * @param {3|6} roomType 房间类型
 * @param {string} avatar 头像
 * @param {string} title 标题
 * @param {boolean} autoIdal 自动接听
 */
export function apiRoomFrontCheck(data: {
  roomType: 3 | 6
  avatar: string
  title: string
  autoIdal: boolean
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/room/front/check',
    method: 'POST',
    data,
    loading: true
  })
}

/**
 * 预览页面获取视频渠道
 */
export function apiRoomVideoChannelList(): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/room/video/channel/list',
    method: 'GET',
    loading: true
  })
}

/**
 * 改变前后台状态
 * @param {number} roomId
 * @param {number} position 麦位
 * @param {1|0} backgroundStatus 状态 1：切后台，0切前台
 */
export function apiRoomMicH5ChangeBackgroundStatus(data: {
  roomId: number
  position: number
  backgroundStatus: 1 | 0
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/room/mic/h5/change/background/status',
    method: 'POST',
    data
  })
}
